import jsPDF from 'jspdf';

export const generateCertificatePDF = (cert) => {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  const W = 297, H = 210, cx = W / 2;

  // Outer background - deep teal
  doc.setFillColor(0, 77, 77);
  doc.rect(0, 0, W, H, 'F');

  // Inner white card
  doc.setFillColor(255, 255, 255);
  doc.roundedRect(12, 12, W - 24, H - 24, 4, 4, 'F');

  // Gold decorative border
  doc.setDrawColor(196, 164, 80);
  doc.setLineWidth(1.5);
  doc.roundedRect(18, 18, W - 36, H - 36, 3, 3);
  doc.setLineWidth(0.5);
  doc.roundedRect(21, 21, W - 42, H - 42, 2, 2);

  // Corner accents
  doc.setDrawColor(196, 164, 80);
  doc.setLineWidth(0.8);
  doc.line(25, 30, 45, 30); doc.line(25, 30, 25, 50);
  doc.line(W - 25, 30, W - 45, 30); doc.line(W - 25, 30, W - 25, 50);
  doc.line(25, H - 30, 45, H - 30); doc.line(25, H - 30, 25, H - 50);
  doc.line(W - 25, H - 30, W - 45, H - 30); doc.line(W - 25, H - 30, W - 25, H - 50);

  // Organization header
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.setTextColor(0, 77, 77);
  doc.text('GROUPE AERH POLYNESIE', cx, 42, { align: 'center' });

  // Thin gold line
  doc.setDrawColor(196, 164, 80);
  doc.setLineWidth(0.6);
  doc.line(cx - 40, 46, cx + 40, 46);

  // Main title
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(30);
  doc.setTextColor(0, 77, 77);
  doc.text('ATTESTATION DE FORMATION', cx, 64, { align: 'center' });

  // "Certifié que"
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(12);
  doc.setTextColor(100, 100, 100);
  doc.text('Certifié que', cx, 80, { align: 'center' });

  // User name
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(26);
  doc.setTextColor(30, 30, 30);
  doc.text(cert.user_name || 'Apprenant', cx, 96, { align: 'center' });

  // Decorative line under name
  doc.setDrawColor(196, 164, 80);
  doc.setLineWidth(0.4);
  doc.line(cx - 55, 100, cx + 55, 100);

  // "a suivi avec succes"
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(12);
  doc.setTextColor(80, 80, 80);
  doc.text('a suivi avec succes la formation', cx, 112, { align: 'center' });

  // Course title
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(20);
  doc.setTextColor(0, 77, 77);
  const titleLines = doc.splitTextToSize(cert.course_title, 200);
  doc.text(titleLines, cx, 127, { align: 'center' });

  const afterTitle = 127 + (titleLines.length - 1) * 8;

  // Details row
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  const dateStr = new Date(cert.issued_at).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' });
  const details = [`Score : ${cert.score}%`, `Date : ${dateStr}`];
  if (cert.course_duration) details.push(`Duree : ${cert.course_duration}`);
  doc.text(details.join('   |   '), cx, afterTitle + 16, { align: 'center' });

  // Signature area
  const sigY = afterTitle + 36;
  doc.setDrawColor(150, 150, 150);
  doc.setLineWidth(0.3);
  doc.line(cx - 30, sigY, cx + 30, sigY);
  doc.setFont('helvetica', 'italic');
  doc.setFontSize(9);
  doc.setTextColor(120, 120, 120);
  doc.text('Groupe AERH Polynésie', cx, sigY + 5, { align: 'center' });
  doc.text('10 Rue Georges Lagarde, Papeete', cx, sigY + 10, { align: 'center' });

  // Certificate reference
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(7);
  doc.setTextColor(170, 170, 170);
  doc.text(`Ref: ${cert.certificate_id}`, cx, H - 20, { align: 'center' });

  doc.save(`Attestation_${cert.course_title.replace(/[^a-zA-Z0-9]/g, '_')}.pdf`);
};
